<template>
  <div class="post-component">
    <!-- [ div.container -->
    <div class="container">
      <div class="contents">
        <Header class="header--post">
          <template #title>{{ AppConst.APP_NAME }}</template>
          <template #menu>
            <router-link to="/" class="reedit-img">
              <CancelButton class="header-btn">家紋を作る</CancelButton>
            </router-link>
          </template>
        </Header>

        <div class="contents__body">
          <div class="post">
            <p class="post__lead">自分だけの家紋画像を作ろう！</p>
            <button type="button" @click="onClickShareTwitterBtn">
              ツイッターでシェアする！
            </button>
            <div class="post-img">
              <img
                class="post-img__img"
                :src="resultImgSrc"
                alt="家紋イラスト"
              />
            </div>
            <p class="post__notice">
              ※PCの場合：画像を右クリックで保存しよう！<br />
              ※スマホの場合：画像を長押しで保存しよう！
            </p>
          </div>
          <!--<form action="/image/post" accept-charset="utf-8" method="post">-->
          <div class="btn-post-twitter-container">
            <!-- 〓投稿画像とテンプレートテキストを twitter に投稿〓 -->
            <!--<EnterButton class="btn-post-twitter">投稿する</EnterButton>-->
          </div>
          <!--</form>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onBeforeMount,
  onMounted,
  onUnmounted,
  ref,
  reactive,
} from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";
import AppConst from "@/consts/app-const";

type Props = {
  id: String;
};

export default defineComponent({
  name: "Post",
  components: {
    CancelButton,
    Header,
  },
  props: {
    // 動的ルートマッチングでrouterから渡ってくる
    id: {
      type: String,
      default: "",
    },
  },
  setup(props: Props) {
    const router = useRouter();
    const toTop = () => router.push({ name: "top" });

    const sns = reactive({
      url: location.href,
      title: "%23" + AppConst.APP_NAME + "で自分だけの %23家紋 を作ろう！",
      body: "あなたの家紋はどんな家紋？",
      hashtags: AppConst.APP_HASHTAG_EN,
    });

    const resultImgSrc = ref<String>("");

    onBeforeMount(() => {
      fetchResultImage(props.id as string);
    });

    onMounted(() => {});

    onUnmounted(() => {});

    function fetchResultImage(imageId: string) {
      const ImageUploadAPI = "/api/image/result";
      const params = new FormData();
      params.append("image_id", imageId);

      axios
        .post(ImageUploadAPI, params)
        .then(function (response) {
          const data = response.data;
          if (data.result) {
            const imageSrc: string = data.image_url;
            setResultImg(imageSrc);
          } else {
            alert("画像の取得に失敗しました。");
            toTop();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    }

    function setResultImg(imageSrc: string) {
      if (imageSrc.match(/https?:\/\//)) {
        resultImgSrc.value = imageSrc;
      } else {
        // XXX 必要に応じてHTTP環境の条件分岐追加
        resultImgSrc.value = "https://" + imageSrc;
      }
    }

    function onClickShareTwitterBtn() {
      let shareURL = "https://twitter.com/share";
      shareURL += "?text=" + sns.title + "%0a" + sns.body;
      shareURL += "&hashtags=" + sns.hashtags;
      shareURL += "&url=" + sns.url;

      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(shareURL, "twitter", option);
    }

    return {
      resultImgSrc,
      onClickShareTwitterBtn,
      AppConst,
    };
  },
});
</script>

<style scoped>
/** TODO postと共通のスタイルを使用しているので、共通化やclass名の汎用化等 */
@import "/app/assets/css/post.css";
.header-btn {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.post__lead {
  color: #e6b422;
  font-family: "Sawarabi Mincho", sans-serif;
  text-shadow: 1px 1px 2px #666666;
  font-size: 3rem;
}
.post-img__img {
  background: #ffffff;
}
</style>
